module.exports = __webpack_public_path__ + "img/0.681de5cc.png";